
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PhilosophySection from './components/PhilosophySection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <PhilosophySection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
